// extracted by mini-css-extract-plugin
export default {"imageBodyWrapper":"custom-upload_imageBodyWrapper__2yurB"};